import React from 'react';
import {Button} from "antd";
import classes from "./buttons.module.css";

const GreenButton = (props) => {
    return (
        <Button {...props} className={classes.greenButton}>
            <span>{props.children}</span>
        </Button>
    );
};

GreenButton.propTypes = {
    ...Button.propTypes, // Use Ant Design Button propTypes
};

export default GreenButton;